import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Tooltip,
  Box,
} from '@mui/material';
import { SOURCE_TYPES, TEXT_NODE_STYLES, CREDIT_FIELDS, CASH_FIELDS, CELL_WIDTH, TABLE_TITLES } from './constants';

const renderHorizontalTable = (title, fields, seedliveInfo) => (
  <TableContainer component={Paper} sx={{ mb: 2, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
    <Typography variant="subtitle1" sx={{ p: 2, fontWeight: 600 }}>
      {title}
    </Typography>

    <Table size="small" sx={{ border: '1px solid #ccc', tableLayout: 'fixed', minWidth: '100%' }}>
      <TableHead>
        <TableRow>
          {fields.map(({ label, field }) => (
            <TableCell
              key={field}
              sx={{
                border: '1px solid #ccc !important',
                fontWeight: 600,
                textAlign: 'center',
                verticalAlign: 'middle',
                p: 1.5,
                whiteSpace: 'nowrap',
                width: CELL_WIDTH,
              }}
              align="center"
            >
              {label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        <TableRow>
          {fields.map(({ field, isError }) => {
            const content =
              seedliveInfo?.[field] !== null && seedliveInfo?.[field] !== undefined && seedliveInfo?.[field] !== ''
                ? seedliveInfo[field].toString()
                : '-';

            const errorTextNode = (
              <Tooltip title={content} arrow>
                <Typography component="span" sx={TEXT_NODE_STYLES}>
                  {content}
                </Typography>
              </Tooltip>
            );

            const regularTextNode = (
              <Tooltip title={content} arrow>
                <span style={TEXT_NODE_STYLES}>{content}</span>
              </Tooltip>
            );

            const isSeedliveInfoPresent =
              seedliveInfo?.[field] !== null && seedliveInfo?.[field] !== undefined && seedliveInfo?.[field] !== '';

            const backgroundColor = isError && isSeedliveInfoPresent ? '#fff5f5' : 'inherit';
            const cursor = isError && isSeedliveInfoPresent ? 'pointer' : 'default';

            return (
              <TableCell
                key={field}
                sx={{
                  border: '1px solid #ccc !important',
                  color: isError ? 'red' : 'inherit',
                  fontWeight: isError ? 600 : 'inherit',
                  backgroundColor,
                  cursor,
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  width: CELL_WIDTH,
                  height: '48px',
                }}
                style={{ padding: '8px' }}
                align="center"
              >
                {content !== '-' ? (isError ? errorTextNode : regularTextNode) : content}
              </TableCell>
            );
          })}
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
);

const SeedliveAccordionTable = ({ seedliveInfo }) => {
  // Determine which table to show based on file_type from backend
  const fileType = seedliveInfo?.['file_type']?.toLowerCase();

  // Show descriptive message if file_type is null, undefined, or invalid
  if (!fileType || (fileType !== SOURCE_TYPES.CREDIT && fileType !== SOURCE_TYPES.CASH)) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No processing data available for this file type
        </Typography>
      </Box>
    );
  }

  // Show Credit Processing table if file_type is 'credit', otherwise show Cash Processing
  const isCreditType = fileType === SOURCE_TYPES.CREDIT;

  const tableTitle = isCreditType ? TABLE_TITLES.CREDIT : TABLE_TITLES.CASH;
  const tableFields = isCreditType ? CREDIT_FIELDS : CASH_FIELDS;

  return <Box sx={{ p: 2 }}>{renderHorizontalTable(tableTitle, tableFields, seedliveInfo)}</Box>;
};

export default SeedliveAccordionTable;
